import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PreferencesService } from './services/preferences.service';
import { VersionUpdatesService } from './services/version-updates-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [
    VersionUpdatesService
  ]
})
export class AppComponent {
  title = 'tankmix-website';
  hasAcceptedTerms: boolean;
  reloadSub: Subscription;
  constructor(private prefs: PreferencesService,
    private router: Router,
    private versionUpdates: VersionUpdatesService,
  ) {
    this.versionUpdates.doNothing();
    this.prefs.termsAndConditions$
      .subscribe(terms => this.hasAcceptedTerms = terms);
  }
}
